import { motion } from "framer-motion";
import { Reveal, Label } from "./Motion";
import { EMBROIDERY } from "../data";

export const Signature = ({ scrollTo }) => (
  <section id="signature" data-testid="signature" className="relative py-24 md:py-36 bg-[#F7F5F0] overflow-hidden">
    <div className="mx-auto max-w-[1400px] px-6 md:px-10">
      <div className="max-w-2xl mb-16">
        <Reveal><Label>Signature Embroidery</Label></Reveal>
        <Reveal delay={0.05}>
          <h2 className="mt-5 font-serif text-4xl sm:text-5xl lg:text-6xl text-[#2c2826] leading-[1.02]">
            Stitched entirely<br /><span className="italic text-[#985F47]">by hand.</span>
          </h2>
        </Reveal>
        <Reveal delay={0.1}>
          <p className="mt-6 text-[#5a5451] leading-relaxed">
            Our hero cushion covers are crewel-embroidered one at a time — hours of wool,
            texture and character you can feel. No two are ever quite the same.
          </p>
        </Reveal>
      </div>

      <div className="grid md:grid-cols-12 gap-5 md:gap-6">
        {EMBROIDERY.map((c, i) => (
          <Reveal
            key={c.id}
            delay={i * 0.1}
            className={i === 0 ? "md:col-span-7 md:row-span-2" : "md:col-span-5"}
          >
            <motion.button
              data-testid={`embroidery-${c.id}`}
              onClick={() => scrollTo("enquire")}
              whileHover="hover"
              className="group relative block w-full h-full text-left overflow-hidden bg-[#EAE5DC]"
            >
              <div className={`relative overflow-hidden ${i === 0 ? "aspect-[4/5] md:h-full" : "aspect-[16/10]"}`}>
                <motion.img
                  src={c.img} alt={c.name}
                  variants={{ hover: { scale: 1.05 } }}
                  transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
                  className="h-full w-full object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#2c2826]/75 via-[#2c2826]/5 to-transparent" />
                <div className="absolute top-4 left-4">
                  <span className="rounded-full bg-[#F7F5F0]/85 backdrop-blur px-3 py-1 text-[11px] uppercase tracking-[0.2em] text-[#5a5451]">
                    {c.tag}
                  </span>
                </div>
                <div className="absolute bottom-0 left-0 p-6 md:p-8">
                  <h3 className="font-serif text-3xl md:text-4xl text-[#F7F5F0]">{c.name}</h3>
                  <p className="mt-2 max-w-sm text-[#e7ddcf] text-sm leading-relaxed">{c.desc}</p>
                  <span className="mt-4 inline-flex items-center gap-2 text-[#F7F5F0] text-sm border-b border-[#F7F5F0]/50 pb-0.5 group-hover:border-[#E8942E] group-hover:text-[#E8942E] transition-colors duration-300">
                    Enquire &rarr;
                  </span>
                </div>
              </div>
            </motion.button>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
